export const actions = {
  add: 'ADD_RESULTS',
  update: 'UPDATE_RESULT',
  clear: 'CLEAR_RESULTS',
  clearType: 'CLEAR_TYPE_RESULTS',
};

export const addResults = programs => ({
  type: actions.add,
  programs: programs,
});

export const updateResult = (id, data) => ({
  type: actions.update,
  id: id,
  data: data,
});

export const clearResults = () => ({
  type: actions.clear,
});

export const clearTypeResults = type => ({
  type: actions.clearType,
  programType: type,
});
